import React, { Component } from 'react';
import SOutOfCoin from 'shared/screens/OutOfCoin';
import './OutOfCoin.scss';
import responsiveFontSize from '../../lib/responsiveFontSize';
import theme from 'shared/assets/style/theme';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import ThemeContext from 'shared/context/ThemeContext';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class OutOfCoin extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-out-of-coin',
    };
  }

  render() {
    const themeContext = this.context;

    return (
      <SOutOfCoin
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { quickBuyOfferDetails, quickBuyHandler, visitStoreHandler } = args;
          const coinAmount = quickBuyOfferDetails.coinAmount ? quickBuyOfferDetails.coinAmount : 0;
          const loyaltyAmount = quickBuyOfferDetails.loyaltyAmount ? quickBuyOfferDetails.loyaltyAmount : 0;
          return (
            <div className="outOfCoinContainer">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <img
                    src={require(asset`images/Out_Of_Coins_Assets/Out_Of_Coins_StaticImage@3x.png`)}
                    alt="Out Of Coins Background"
                    style={{ height: '100%', width: '100%' }}
                  />
                  <div style={themeContext.OutOfCoin.QuickBuyOfferDetails}>
                    <div
                      className="quickBuyCoinContainer"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                      }}
                    >
                      <img
                        src={require(asset`images/Top_Bar_Assets/Coin_Icon@3x.png`)}
                        className="OOCIcon"
                        alt="Coin Icon"
                      />
                      <span
                        className={`OOCText OOCGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                        data-label={coinAmount}
                      >
                        {coinAmount}
                      </span>
                    </div>
                    <div
                      className="quickBuyLoyaltyContainer"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                      }}
                    >
                      <span
                        className="quickBuyPlusIcon"
                        style={{
                          alignSelf: 'center',
                          fontSize: responsiveFontSize(14, 26),
                        }}
                      >
                        {quickBuyOfferDetails.plusIcon}
                      </span>
                      <img
                        src={require(asset`images/Top_Bar_Assets/Loyalty_Star_Icon@3x.png`)}
                        className="loyaltyIcon"
                        alt="Loyalty Icon"
                        style={{
                          width: '6%',
                          alignSelf: 'center',
                        }}
                      />
                      <span
                        className={`OOCGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                        style={{
                          fontWeight: 600,
                          textShadow: `2px 2px 4px ${theme.palette.secondary[0]}`,
                          marginLeft: 0,
                          alignSelf: 'center',
                          display: 'inline-block',
                          fontSize: responsiveFontSize(14, 26),
                        }}
                        data-label={loyaltyAmount}
                      >
                        {loyaltyAmount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="outOfCoinButtons">
                <div className="outOfCoinButton" style={{ left: '8%' }} onClick={quickBuyHandler}>
                  <img
                    style={{ width: '50%' }}
                    src={require(asset`RoundedRect_Green@2x.png`)}
                    alt="Purchase Quick Buy Offer"
                  />
                  <p
                    className="outOfCoinButtonLabel"
                    style={{
                      fontSize: responsiveFontSize(14, 26),
                    }}
                  >
                    {quickBuyOfferDetails.totalAmount}
                  </p>
                </div>
                <div className="visitStoreButton" style={{ right: '8%' }} onClick={visitStoreHandler}>
                  <img style={{ width: '50%' }} src={require(asset`RoundedRect_Orange@3x.png`)} alt="Visit Store" />
                  <p
                    className="visitStoreButtonLabel"
                    style={{
                      fontSize: responsiveFontSize(14, 22),
                    }}
                  >
                    {getText(TEXT_KEY.VISIT_STORE)}
                  </p>
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

OutOfCoin.contextType = ThemeContext;
OutOfCoin.hideOverlay = true;

